export default {
  chatWidget: {
    chatWithUs: '채팅',
    welcomeTitle: 'Bookivo에 오신 것을 환영합니다!',
    welcomeMessage: '오늘 어떻게 도와드릴까요?',
    continueChat: '대화 계속하기',
    startConversation: '대화 시작하기',
    formTitle: '당신에 대해 더 알려주세요',
    namePlaceholder: '이름',
    emailPlaceholder: '이메일',
    phonePlaceholder: '전화번호',
    nameRequired: '이름을 입력해주세요',
    emailRequired: '이메일을 입력해주세요',
    emailInvalid: '유효한 이메일 주소를 입력해주세요',
    phoneRequired: '전화번호를 입력해주세요',
    startChat: '채팅 시작',
    chatTitle: '고객 지원 채팅',
    chatTitleNoAgent: '연결 중...',
    endChat: '채팅 종료',
    inputPlaceholder: '메시지를 입력하세요...',
    greeting: '안녕하세요',
    greetingMessage: '오늘 어떻게 도와드릴까요?',
    emoji: '이모티콘',
    uploadImage: '이미지 업로드',
    sending: '전송 중...',
    uploadFailed: '업로드 실패, 다시 시도해주세요',
    fileTooLarge: '파일 크기는 10MB를 초과할 수 없습니다',
    invalidFileType: '이미지 파일만 업로드할 수 있습니다',
    sendFailed: '메시지 전송 실패, 다시 시도해주세요',
    imageSendFailed: '이미지 전송 실패, 다시 시도해주세요',
    connectionLost: '연결이 끊어졌습니다. 채팅을 닫고 다시 연결해주세요',
    uploading: '이미지 업로드 중...',
    sessionEnded: '세션이 종료되었습니다',
    rating: {
      title: '서비스를 이용해 주셔서 감사합니다. 경험을 평가해주세요!',
      satisfied: '만족',
      dissatisfied: '불만족',
      placeholder: '의견을 말씀해 주세요',
      submit: '평가 제출',
      endChat: '종료',
      backToChat: '채팅으로 돌아가기',
      success: '피드백을 주셔서 감사합니다!'
    }
  }
}
